import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import {
  resolveInteractiveElement,
  resolveActiveProps,
} from "../../utils/resolveElement";
import css from "./NavigationBar.module.css";

const NavigationBarRoot = React.forwardRef(
  ({ label = "Main", className, children, ...rest }, ref) => (
    <nav
      ref={ref}
      aria-label={label}
      className={clsx(css.root, className)}
      {...rest}
    >
      <ul className={css.list}>{children}</ul>
    </nav>
  ),
);

NavigationBarRoot.displayName = "NavigationBarRoot";

NavigationBarRoot.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

const NavigationBarItem = React.forwardRef(
  ({ href, active = false, icon, label, onClick, className, ...rest }, ref) => {
    const Element = resolveInteractiveElement({ href });
    const activeProps = resolveActiveProps({ href, active });

    return (
      <li>
        <Element
          ref={ref}
          href={href}
          onClick={onClick}
          type={href ? undefined : "button"}
          className={clsx(css.item, className)}
          data-active={active || undefined}
          {...activeProps}
          {...rest}
        >
          <span className={css.itemIcon}>{icon}</span>
          <span className={css.itemLabel}>{label}</span>
        </Element>
      </li>
    );
  },
);

NavigationBarItem.displayName = "NavigationBarItem";

NavigationBarItem.propTypes = {
  href: PropTypes.string,
  active: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

const NavigationBar = {
  Root: NavigationBarRoot,
  Item: NavigationBarItem,
};

export default NavigationBar;
